import store from '@/store/index';
import Firebase from './Firebase.js'
import { getFirestore } from "firebase/firestore";
import { Capacitor } from '@capacitor/core';
import {version} from '../../package.json';

// ----------------------------- o

const db = Firebase.firestore()

// ----------------------------- o

export default {
    async firestoreInit() {
        const token = store.state.auth.deviceToken
        if (!token) return false;
        //
        const devices = db.collection('devices');
        const data = {
            token: token,
            platform: Capacitor.platform,
            updated: Date.now(),
            version: version
        }

        return devices.doc(token).set(data)
            .then(() => {
                console.log("Firestore successfully written!");
            })
            .catch((error) => {
                console.error("Error writing to Firestore: ", error);
            })
    }
}